export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14376.63771c1e.jpg";